// reducers/comment_form.js
import {List as ImmutableList, Map as ImmutableMap} from 'immutable';

import {
  CLOSE_COMMENT_FORM,
  OPEN_COMMENT_EDIT_FORM,
  CLOSE_REPLY_COMMENT_FORM,
  OPEN_COMMENT_FORM,
  OPEN_REPLY_COMMENT_FORM
} from 'mastodon/actions/comment_form';
import { uuid } from 'mastodon/uuid';

const initialState = ImmutableMap({
  replyAccountNames: '',
  replyDisplayNames: '',
  isCommentFormOpen: false, // Trạng thái mở form toàn cục
  isCommentReplyFormOpen: false,
  commentId: null,
});
export default function commentForm(state = initialState, action) {
  switch (action.type) {
  case OPEN_COMMENT_FORM:
    return state.set('isCommentFormOpen', true).set('isCommentReplyFormOpen', false);
  case OPEN_COMMENT_EDIT_FORM:
    const mentions = action.status.get('mentions') || ImmutableList();
    const replyAccountNames = mentions.map(m => m.get('username')).toArray();
    const replyDisplayNames = mentions.map(m => m.get('display_name')).toArray();

    return state
      .set('isCommentFormOpen', true)
      .set('isCommentReplyFormOpen', true)
      .set('replyAccountNames', replyAccountNames)
      .set('replyDisplayNames', replyDisplayNames);
  case CLOSE_COMMENT_FORM:
    return state.set('isCommentFormOpen', false);
  case OPEN_REPLY_COMMENT_FORM:
    return state.set('commentId', action.id).set('isCommentReplyFormOpen', true);
  case CLOSE_REPLY_COMMENT_FORM:
    return state.set('commentId', null).set('isCommentReplyFormOpen', false);
  default:
    return state;
  }
}
